import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { client } from '../api';
import PageContainer from './PageContainer';
import { LoadingSpinner } from 'design-system/src/components/LoadingSpinner/LoadingSpinner';
import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';
import { loadExternalScript } from 'shared-utils/utils/loadExternalScript';

declare global {
  // TODO(WIT-4362): fix
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      ['explo-dashboard']: any;
    }
  }
}

const DashboardEmbed: React.FC = () => {
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [scriptError, setScriptError] = useState(false);

  // Load the external script
  useEffect(() => {
    loadExternalScript({ id: 'explo-embed-script', src: 'https://embed.explo.co/bundle.js' })
      .then(() => setScriptLoaded(true))
      .catch(() => {
        console.error('Failed to load Explo embed script.');
        setScriptError(true);
      });
  }, []);

  const { data, isLoading, error } = useQuery<{ jwt: string }>({
    queryKey: ['explo-jwt'],
    queryFn: () => {
      return client.post(`explo-jwt`).then((res) => res.data);
    },
  });

  let body;

  if (isLoading || !scriptLoaded) {
    // Either loading the JWT or loading the script
    body = <LoadingSpinner />;
  } else if (error || scriptError) {
    body = <PageLoadError />;
  } else if (data) {
    body = (
      <explo-dashboard
        dash-jwt={data.jwt}
        updateUrlParams={true}
        isProduction={true}
        environment="production"
        refresh-minutes={10}
        theme="tandem_portal"
      ></explo-dashboard>
    );
  }

  return <PageContainer title="Analytics">{body}</PageContainer>;
};

export default DashboardEmbed;
